(function(){
    // No need for lookup service here, it resides in common folder
    angular.module('tmx-app').factory('UserLimitManagementService', ['TMX_FINANCE_CONSTANTS','tmxResource','UsersService','lookupService',
    
        function UserLimitManagementService(TMX_FINANCE_CONSTANTS,tmxResource,UsersService,lookupService){
    
            var UserLimitManagementService = tmxResource("User");

            UserLimitManagementService.getLimitById = function(id){
                return UserLimitManagementService.getByAction("/GetLimitById/"+id);
            }
            
            UserLimitManagementService.SaveLimitData = function(data){
                return UserLimitManagementService.getByAction("SaveUserLimit", false,'post',data);
            }
            UserLimitManagementService.DeleteLimitById = function(id){
                return UserLimitManagementService.getByAction("DeleteLoanLimitById/"+id,false,'put');
            }
            UserLimitManagementService.changeLoanLimits = function(data){
                return UserLimitManagementService.getByAction("ChangeLoanLimit",false, 'put',data);
            }
            UserLimitManagementService.GetGridColumns = function(){
                var userTypes = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.USER);
                var gridColumn = [
                    {
                        field: "UserName",
                        title: "Name",
                        type: "text",        
                        template: "<md-button class='tmx-primary-text-grid' ng-disabled='!UserLimitManagementCtrl.editPermission' ng-click='UserLimitManagementCtrl.clickEdit(dataItem)' ng-bind='dataItem.UserName'></md-button>  </div>  ",
                        headerTemplate: "<span  ng-class=\"{ 'filter-active' : UserLimitManagementCtrl.isFiltered('UserName')}\" >{{'UserName' | translate}}<i class='fa fa-filter'ng-if='UserLimitManagementCtrl.isFiltered(\"UserName\")' ></i></span>"
                    },
                    {
                        field: "RoleName",
                        title: "Role",
                        type: "text",
                        hidden:false,                    
                        template: "{{dataItem.RoleName}}",
                        headerTemplate: "<span class=\"k-link\"  ng-class=\"{ 'filter-active' : UserLimitManagementCtrl.isFiltered('RoleName')}\" >{{'Role' | translate}}<i class='fa fa-filter' ng-if='UserLimitManagementCtrl.isFiltered(\"RoleName\")' ></i></span>"
                    },
                    {
                        field: "BranchName",
                        title: "BranchName",                    
                        type: "select",
                        data: UsersService.branches,              
                        headerTemplate: "<span  ng-class=\"{ 'filter-active' : UserLimitManagementCtrl.isFiltered('BranchName')}\" >{{'BranchName' | translate}}<i class='fa fa-filter' ng-if='UserLimitManagementCtrl.isFiltered(\"BranchName\")' ></i></span>"
                    },
                    {
                        field: "UserType",
                        title: "DeviationLevel",
                        type: "select",
                        data: userTypes,
                        template:"{{dataItem.UserType}}",
                    // isNumber: true,                    
                        headerTemplate: "<span  ng-class=\"{ 'filter-active' : UserLimitManagementCtrl.isFiltered('UserTypeLkp')}\" >{{'DeviationLevel' | translate}}<i class='fa fa-filter' ng-if='UserLimitManagementCtrl.isFiltered(\"UserTypeLkpID\")' ></i></span>"
                    },
                    {
                        field: "AmountFrom",
                        title: "MinAmount",
                        type: "amount",
                        template:"{{UserLimitManagementCtrl.formatAmount(dataItem.AmountFrom)}}",
                    // isNumber: true,                    
                        headerTemplate: "<span  ng-class=\"{ 'filter-active' : UserLimitManagementCtrl.isFiltered('AmountFrom')}\" >{{'MinAmount' | translate}}<i class='fa fa-filter' ng-if='UserLimitManagementCtrl.isFiltered(\"AmountFrom\")' ></i></span>"
                    },
                    {
                        field: "AmountTo",
                        title: "MaxAmount",
                        type: "amount",
                        template:"{{UserLimitManagementCtrl.formatAmount(dataItem.AmountTo)}}",
                    // isNumber: true,                    
                        headerTemplate: "<span  ng-class=\"{ 'filter-active' : UserLimitManagementCtrl.isFiltered('AmountTo')}\" >{{'MaxAmount' | translate}}<i class='fa fa-filter' ng-if='UserLimitManagementCtrl.isFiltered(\"AmountTo\")' ></i></span>"
                    },
                    {
                        title: "",
                        width: "5%",
                        template: "<md-menu md-position-mode=\"target-right target\" flex='none' class='menu-list-item' md-offset='-20 60'>"
                                        +"<md-button  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons margin-right-24'>more_vert</md-icon></md-button>"
                                            +"<md-menu-content width='2' >"
                                                +"<md-menu-item><md-button aria-label='delete' class='tmxMin' ng-disabled='!UserLimitManagementCtrl.deletePermission' ng-click='UserLimitManagementCtrl.clickDelete(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>delete</md-icon>Delete</md-button></md-menu-item>"
                                                +"<md-menu-item><md-button aria-label='edit' class='tmxMin' ng-disabled='!UserLimitManagementCtrl.editPermission' ng-click='UserLimitManagementCtrl.changeLimit(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>edit</md-icon>Change Limits</md-button></md-menu-item>"
                                                +"</md-menu-content>"
                                            +"</md-menu>"
                    }
                ];
                return gridColumn;
            }

            return UserLimitManagementService;
        }
    ]);
    
})();